import getDefaultDashboardRoute from '@/common/utils/defaultDashboardRoute';
import {
  ArrowLeftIcon,
  CreditCardIcon,
  GearIcon,
  StudentIcon,
  UserIcon,
  UsersIcon,
  UsersThreeIcon,
} from '@phosphor-icons/react';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@shadcn/components/sidebar';
import { cn } from '@shadcn/lib/utils';
import { useLocation, useNavigate } from 'react-router-dom';

const items = {
  Account: [
    {
      title: 'Profile',
      url: '/dashboard/settings/profile',
      icon: <UserIcon weight="light" />,
    },
    {
      title: 'My Organisations',
      url: '/dashboard/settings/my-organisations',
      icon: <UsersThreeIcon weight="light" />,
    },
  ],
  Organisation: [
    {
      title: 'Organisation Settings',
      url: '/dashboard/settings/organisation',
      icon: <GearIcon weight="light" />,
    },
    {
      title: 'Manage & Invite Members',
      url: '/dashboard/settings/members',
      icon: <UsersIcon weight="light" />,
    },
    {
      title: 'Billing & Subscription',
      url: '/dashboard/settings/billing',
      icon: <CreditCardIcon weight="light" />,
    },
    {
      title: 'Default Learner Settings',
      url: '/dashboard/settings/learner-settings',
      icon: <StudentIcon weight="light" />,
    },
  ],
};

export default function SettingsSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const sidebar = useSidebar();

  function getIsActive(url: string) {
    if (location.pathname.includes(url)) {
      return true;
    }
    return false;
  }

  return (
    <Sidebar collapsible="icon" className="pt-2">
      <SidebarHeader
        className="cursor-pointer"
        onClick={() => navigate(getDefaultDashboardRoute())}
      >
        <SidebarMenuButton className="text-base [&>svg]:size-5">
          <ArrowLeftIcon
            size={20}
            className={cn(sidebar.state === 'collapsed' && 'ml-0.5')}
          />
          <span>Settings</span>
        </SidebarMenuButton>
      </SidebarHeader>
      <SidebarContent>
        {Object.entries(items).map(([group, items]) => (
          <SidebarGroup key={group}>
            <SidebarGroupLabel>{group}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {items.map(({ title, url, icon }) => (
                  <SidebarMenuItem key={title}>
                    <SidebarMenuButton
                      className="[&>svg]:size-5"
                      onClick={() => navigate(url)}
                      isActive={getIsActive(url)}
                    >
                      {icon}
                      <span>{title}</span>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  );
}
